/**
 * Gateway API paths — the single place the surface is named.
 * Moving it again is one edit here, not fourteen call sites.
 */

// The neutral domain. Replaced `/controlServer/gateways`, which was vendor-scoped even
// though TTLock gateways run through the same routes. See the server's gateways domain doc.
// One route did NOT move with it — see `locks` below.
const BASE = '/gateways';

/** Paths that take no gateway. */
export const gatewayApi = {
	monitor: `${BASE}/monitor`,
	// Every gateway's day buckets in ONE read, no vendor call. Scoped server-side to the
	// gateway categories, so it covers TTLock and Control alike. The grid draws its strips
	// from this; asking per row was one request per gateway to fill a single column.
	history: `${BASE}/history`,
	sync: `${BASE}/sync`
};

/**
 * Paths for one gateway. Functions rather than templates so a caller cannot
 * assemble a path by hand and drift from the rest.
 *
 * `deviceID` is our DeviceID; the server also accepts the vendor's gatewayId.
 */
export const gatewayApiFor = (deviceID) => ({
	root: `${BASE}/${deviceID}`,
	// Prefer this over the flat gatewayApi.check: with the id in the PATH the server's audit
	// row carries the gateway's entityID, which the body-shaped call cannot supply.
	check: `${BASE}/${deviceID}/check`,
	// One read, both resolutions: the per-day buckets the strip draws and the raw check
	// timeline the feed lists. A gateway has no unlocks — a DEVICE's unlock activity is
	// /logs/accessLogs?deviceID, a different question.
	history: `${BASE}/${deviceID}/history`,
	/*
	 * 🛑 THE ONE PATH STILL UNDER `/controlServer`, and deliberately so — do NOT "fix" it to
	 * match the BASE above. The gateway↔lock binding is read from the Control server's own
	 * heartbeat history, which is where that record lives; the neutral `/gateways/:id/locks`
	 * route does not serve it. Every other path here is vendor-agnostic because the question
	 * it answers is ("is this gateway up", "what happened to it") — this one is not.
	 */
	locks: `/controlServer${BASE}/${deviceID}/locks`,
	firmwareCheck: `${BASE}/${deviceID}/firmware-check`
});

// 🛑 The staff Inventory "Control Gateways" tab does NOT belong here. It reads the vendor's
// hardware pool — a different question from "what can this org talk to now" — so its path lives
// with its saga, in `reduxStore/inventory/saga`. Never point that tab at `GET /gateways`.
